import React, { Fragment } from "react";
import { connect } from "react-redux";
import Awaiting from "../components/logistics/Awaiting";
import FulfillmentMarkers from "../components/logistics/FulfillmentMarkers";
import Fulfillments from "../components/logistics/Fulfillments";
import { getLogisticsInfo } from "../actions/logisticsAction";
import Spinner from "../components/layout/Spinner";
import OrdersCancelled from "../components/logistics/OrdersCancelled";
class LogisticsContainer extends React.Component {
  componentDidMount() {
    this.props.getLogisticsInfo();
  }

  render() {
    const { loading, logisticsInfo } = this.props.logisticsInfo;
    return (
      <Fragment>
        {loading ? (
          <Spinner />
        ) : (
          <Fragment>
            {this.props.tab === "fulfillments" && (
              <Fulfillments
                fulfillments={logisticsInfo.fulfillments}
                drivers={logisticsInfo.drivers}
              />
            )}
            {this.props.tab === "fulfillmarkers" && (
              <FulfillmentMarkers
                fulfillments={logisticsInfo.fulfillments}
              />
            )}
            {this.props.tab === "cancelled" && (
              <OrdersCancelled
                deliveries={logisticsInfo.cancelled_deliveries}
                orders={logisticsInfo.cancelled_orders}
              />
            )}
            {this.props.tab === "awaiting" && (
              <Awaiting
                awaiting={logisticsInfo.awaiting}
                drivers={logisticsInfo.drivers}
              />
            )}
          </Fragment>
        )}
      </Fragment>
    );
  }
}
const mapStateToProps = ({ logisticsInfo, deliveries }) => ({
  logisticsInfo: logisticsInfo,
  deliveries: deliveries,
});
const mapDispatchToProps = (dispatch) => ({
  getLogisticsInfo: (logisticsInfo) =>
    dispatch(getLogisticsInfo(logisticsInfo)),
});
export default connect(mapStateToProps, mapDispatchToProps)(LogisticsContainer);
